import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-1,1h3v0.5h-3z' },
    {
      paint: 'sprinklerMetal',
      d: 'M-0.5,-4.5h0.5v1h-0.5zM-1.5,-3.5h0.5v0.5h-0.5zM2,-2h1v0.5h-1zM-1.5,0h0.5v0.5h-0.5zM1,0h1v1h-1zM-2,0.5h1.5v0.5h-1.5zM-1.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'iceCreamCart',
      d: 'M-2,-2h0.5v0.5h-0.5zM-2,-1.5h2v0.5h-2zM-2,-1h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM-2,-0.5h2.5v0.5h-2.5zM-1,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['iceCreamCart', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-1,-3.5h0.5v0.5h-0.5zM-0.5,-2.5h1v0.5h-1zM0,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM0.5,-1.5h2v1.5h-2zM-2,0h0.5v0.5h-0.5zM0.5,0h0.5v0.5h-0.5zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'parasolStripe',
      d: 'M-1,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-1.5,-2.5h1v0.5h-1zM0.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h1.5v0.5h-1.5zM1,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM-1,-1h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-1,-3h1v0.5h-1z' },
    {
      paint: 'iceCreamUmbrella',
      d: 'M-1,-5h1v0.5h-1zM-2,-4.5h1v0.5h-1zM0.5,-4.5h1v0.5h-1zM-2.5,-4h1v1h-1zM0,-4h0.5v1h-0.5zM1.5,-4h0.5v0.5h-0.5zM1,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['iceCreamUmbrella', 0.75],
        ['trunk', 0.25],
      ],
      d: 'M0,-4.5h0.5v0.5h-0.5zM0.5,-4h1v0.5h-1zM-0.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 95,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-1,1h3v0.5h-3z' },
    {
      paint: 'sprinklerMetal',
      d: 'M-0.5,-4.5h0.5v1h-0.5zM-1.5,-3.5h0.5v0.5h-0.5zM2,-2h1v0.5h-1zM-1.5,0h0.5v0.5h-0.5zM1,0h1v1h-1zM-2,0.5h1.5v0.5h-1.5zM-1.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'iceCreamCart',
      d: 'M-2,-2h0.5v0.5h-0.5zM-2,-1.5h2v0.5h-2zM-2,-1h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM-2,-0.5h2.5v0.5h-2.5zM-1,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['iceCreamCart', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-1,-3.5h0.5v0.5h-0.5zM-0.5,-2.5h1v0.5h-1zM0,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM0.5,-1.5h2v1.5h-2zM-2,0h0.5v0.5h-0.5zM0.5,0h0.5v0.5h-0.5zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'parasolStripe',
      d: 'M-1,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-1.5,-2.5h1v0.5h-1zM0.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h1.5v0.5h-1.5zM1,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM-1,-1h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-1,-3h1v0.5h-1z' },
    {
      paint: 'iceCreamUmbrella',
      d: 'M-1,-5h1v0.5h-1zM-2,-4.5h1v0.5h-1zM0.5,-4.5h1v0.5h-1zM-2.5,-4h1v1h-1zM0,-4h0.5v1h-0.5zM1.5,-4h0.5v0.5h-0.5zM1,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['iceCreamUmbrella', 0.75],
        ['trunk', 0.25],
      ],
      d: 'M0,-4.5h0.5v0.5h-0.5zM0.5,-4h1v0.5h-1zM-0.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5z',
    },
    { paint: 'parasolRed', d: 'M2,-3.5h0.5v0.5h-0.5zM2,-3h1.5v0.5h-1.5z' },
  ],
  pixels: 99,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-1,1h3v0.5h-3z' },
    {
      paint: 'sprinklerMetal',
      d: 'M-0.5,-4.5h0.5v0.5h-0.5zM2,-2h1v0.5h-1zM-1.5,0h0.5v0.5h-0.5zM1,0h1v1h-1zM-2,0.5h1.5v0.5h-1.5zM-1.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'iceCreamCart',
      d: 'M-2,-2h0.5v0.5h-0.5zM-2,-1.5h2v0.5h-2zM-2,-1h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM-2,-0.5h2.5v0.5h-2.5zM-1,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['iceCreamCart', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-1,-3.5h0.5v0.5h-0.5zM-0.5,-2.5h1v0.5h-1zM0,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM0.5,-1.5h2v1.5h-2zM-2,0h0.5v0.5h-0.5zM0.5,0h0.5v0.5h-0.5zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'parasolStripe',
      d: 'M-1,-4.5h0.5v0.5h-0.5zM-1.5,-4h1v0.5h-1zM-1.5,-2.5h1v0.5h-1zM0.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-1.5,-2h1.5v0.5h-1.5zM1,-2h0.5v0.5h-0.5zM0,-1.5h0.5v0.5h-0.5zM-1,-1h1v0.5h-1z',
    },
    { paint: 'bareBranch', d: 'M-1,-3h1v0.5h-1z' },
    {
      paint: 'iceCreamUmbrella',
      d: 'M-1,-5h1v0.5h-1zM-2,-4.5h1v0.5h-1zM0.5,-4.5h1v0.5h-1zM-2.5,-4h1v1h-1zM0,-4h0.5v1h-0.5zM1.5,-4h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['iceCreamUmbrella', 0.75],
        ['trunk', 0.25],
      ],
      d: 'M0,-4.5h0.5v0.5h-0.5zM0.5,-4h1v0.5h-1zM-0.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h0.5v0.5h-0.5z',
    },
    { paint: 'sandcastleWall', d: 'M1,-2.5h0.5v0.5h-0.5z' },
    {
      paint: 'cherryPetalPink',
      d: 'M-0.5,-4h0.5v0.5h-0.5zM-1.5,-3.5h0.5v0.5h-0.5zM1,-3.5h1v1h-1z',
    },
  ],
  pixels: 97,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
